<template>
  <div>
    <div class="form-group row">
      <label :for="safeId('name')" class="col-sm-4 col-form-label">Name</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" :id="safeId('name')" v-model.trim="localName">
      </div>
    </div>
    <div class="form-group row justify-content-end">
      <div class="col-sm-8">
        <button type="button" class="btn btn-primary" @click="save">Save</button>
        <button type="button" class="btn btn-secondary" @click="reset">Cancel</button>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4 col-form-label">Danger zone</label>
      <div class="col-sm-8">
        <p class="form-text">Once you delete an album, all pictures will be deleted, too. There is no going back. Please be certain. </p>
        <button type="button" class="btn btn-danger" @click="remove">Delete Album</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { windowPropsMixin } from '../mixins'
  import * as action from '../store/action-types'

  export default {
    name: 'album-settings',
    mixins: [windowPropsMixin],
    props: ['albumId'],
    data () {
      return {
        localName: ''
      }
    },
    computed: {
      album () {
        return this.$store.getters.album(this.albumId) || {}
      },
      computedName () {
        return this.album.name || this.windowTitle
      }
    },
    created () {
      this.reset()
    },
    watch: {
      computedName: function (val) {
        this.localName = val
      }
    },
    methods: {
      save () {
        this.windowTitle = this.localName
        this.$store.dispatch(action.ALBUM_META, {
          albumId: this.albumId,
          name: this.localName
        })
      },
      reset () {
        this.localName = this.computedName
      },
      remove () {
        this.$store.dispatch(action.ALBUM_DELETE, {
          windowId: this.windowId,
          albumId: this.albumId
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/album-settings.vue